export default {
  SET_SHOWN_MODAL: (state, val) => { state.isShown = val; },
  SET_TRANSACTIONS_ID: (state, val) => { state.transactionsId = val; },
  SET_TYPE_MODAL: (state, val) => { state.typeModal = val; },
  SET_ERRORS: (state, val) => { state.errors = val; },
};
